import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import { OAuthAppMembers, TOAuthIntegration } from "../../../../../Integrations"

export default function OAuthIntegrationMembersPage() {
	const context = useOutletContext<{ integration: TOAuthIntegration }>()

	return (
		<>
			<Helmet>
				<title>Members | OAuth App</title>
			</Helmet>
			<OAuthAppMembers integration={context.integration} />
		</>
	)
}
